<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <Counters msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
// @ is an alias to /src
import Counters from "@/components/Counters.vue";

export default {
  name: "Home",
  components: {
    Counters
  }
};
</script>
